module.exports = __webpack_public_path__ + "assets/img/bob.07bc4f4c.png";